// @ts-nocheck



import CommonApi from './../commonApi';
import { convertFromKopToRub } from '../pure/unitConversions';

export const convertDataFromServer = (oilsAct) => ({
  ...oilsAct,
  sum: convertFromKopToRub(oilsAct.sum)
});

const oilsAct = new CommonApi(
  'oilsAct',
  'акт списания масел',
  undefined,
  convertDataFromServer
);

export default {
  ...oilsAct
};
